import { useState, useEffect } from 'react';

const ProfileImage = ({ src, alt="", clientId, smylorLogo } :any) => {
  const [isTallImage, setIsTallImage] = useState(false);

  useEffect(() => {
    if (!src) return;

    const img = new Image();
    img.src = src;
    img.onload = () => {
      setIsTallImage(img.height > img.width);
    };
  }, [src]);

  const onError = ({ currentTarget }: any) => {
    currentTarget.onerror = null;
    currentTarget.src = smylorLogo;
  };

  return (
    <a aria-label="dentist-profile-image" href={`/?clientId=${clientId}`}>
      <div className="w-[100px] h-[60px] overflow-hidden flex align-middle justify-center rounded-md">
        <img
          src={src}
          alt={alt}
          className={`${
            isTallImage ? 'h-full w-auto' : 'w-full h-auto'
          } object-contain`}
          onError={onError}
        />
      </div>
    </a>
  );
};

export default ProfileImage;
